import { PagedMultiSelectField, PagedSingleSelectField, laravelServiceSelectFetchConfig } from "@dgs/core";
import { FC } from "react";
import { countryService } from "../api/countryService";

interface Props {
	name: string;
	label: string;
	required?: boolean;
	clearable?: boolean;
}

export const CountrySelectField: FC<Props> = (props) => {
	return <PagedSingleSelectField {...props} fetchConfig={laravelServiceSelectFetchConfig(countryService)} />;
};

export const CountryMultiSelectField: FC<Props> = (props) => {
	return <PagedMultiSelectField {...props} fetchConfig={laravelServiceSelectFetchConfig(countryService)} />;
};
